import { useState } from 'react';
import { useHistory, RouterProps } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Button, Checkbox, ErrorToast } from '../../components';
import { ContentBlockModal } from '../../components/common/ContentBlockModal';
import Spinner from '../../components/common/Spinner';
import { getContentBlock } from '../../slices/content-block-slice';
import { P3 } from '../../styles/FontStyles';
import {
  AuthLayoutSubTitle,
  AuthLayoutTitle,
  Flexed
} from '../../styles/GlobalComponents';
import { colors, globalImages, lightTheme } from '../../styles/GlobalStyles';
import { setMavieMigrationModalChecked } from './MigrationTermsPrivacy.actions';
import { LOGIN } from '../../routes/routes';
import { Layout, Main } from '../../layout/AuthLayout/authLayoutStyled';
import { checkSideModal } from '../Dashboard/Dashboard.actions';
import { ProgressSvg } from '../TermsConditions/TermsConditions';
import { AuthLogo } from '../../styles/stylesStyled';

const MigrationTermsPrivacy = ({
  setTermsConditionsModal,
  isMavieMigrationModalChecked
}: {
  isMavieMigrationModalChecked: boolean;
  setTermsConditionsModal: (modal: boolean) => void;
}) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [checkbox, setCheckbox] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [checkbox3, setCheckbox3] = useState(false);
  const { loading, contentBlock } = useAppSelector(
    (state) => state.contentBlock
  );
  const { userInfo } = useAppSelector((state) => state.auth);
  const user = userInfo.user;

  const getContentBlockHandler = async () => {
    dispatch(
      getContentBlock({
        contentBlockId: 115,
        languageId: 1,
        functionCallback: () => setModal(true)
      })
    );
  };

  const getPoliciesAndProceduresHandler = () => {
    dispatch(
      getContentBlock({
        contentBlockId: 120,
        languageId: 1,
        functionCallback: () => setModal2(true)
      })
    );
  };

  const handleSubmit = async () => {
    if (!isMavieMigrationModalChecked) {
      if (!checkbox || !checkbox2 || !checkbox3) {
        return ErrorToast('Please check the checkboxes to continue');
      }
    } else {
      if (!checkbox || !checkbox2) {
        return ErrorToast('Please check the checkboxes to continue');
      }
    }

    if (!isMavieMigrationModalChecked) {
      dispatch(setMavieMigrationModalChecked(setTermsConditionsModal));
      dispatch(checkSideModal(history));
    } else {
      dispatch(checkSideModal(history));
      setTermsConditionsModal(false);
    }
  };

  const showReferrer = () => {
    if (userInfo?.referrer?.name) {
      if (
        userInfo?.referrer?.name === 'Matjaz' &&
        userInfo?.referrer?.surname === 'Torč'
      ) {
        return <></>;
      } else {
        return (
          <P3 bold center color={colors.primary900} mb='20'>
            Referred by {userInfo?.referrer?.name} {userInfo?.referrer?.surname}
          </P3>
        );
      }
    } else {
      return (
        <P3 bold center color={colors.primary900} mb='20'>
          Referred by {user?.referrerId}
        </P3>
      );
    }
  };

  return (
    <Main>
      {loading && <Spinner fullScreen={true} transparent />}
      <AuthLogo>
        <img src={globalImages.authLayoutLogo} alt='logo' />
      </AuthLogo>
      <AuthLayoutTitle>Join the Freelauch</AuthLayoutTitle>
      <AuthLayoutSubTitle>Become a United One Partner</AuthLayoutSubTitle>
      {isMavieMigrationModalChecked && (
        <Flexed center justifyCenter m='20px 0' style={{ scale: '0.9' }}>
          <ProgressSvg />
        </Flexed>
      )}
      {/* {userInfo?.referrer?.name !== 'Matjaz' &&
        userInfo?.referrer?.surname !== 'Torč' && (
          <P3 bold center color={colors.primary900} mb='20' mt='20'>
            Referred by {userInfo?.referrer?.name} {userInfo?.referrer?.surname}
          </P3>
        )} */}

      {showReferrer()}

      {!isMavieMigrationModalChecked && (
        <P3 center mb='20' mt='20'>
          We've found your number account <span>{user?.id}</span>. To continue,
          we need your authorization to transfer your data to United One.
        </P3>
      )}
      {!isMavieMigrationModalChecked && (
        <Flexed center mb='30' m='0 40px' mbSM='24' mSM='0'>
          <Checkbox
            checkColor={colors.primary900}
            margin={'0 5px 0 0'}
            checked={checkbox3}
            onClick={() => setCheckbox3(!checkbox3)}
          />
          <P3 ml='6'>
            I authorize the transfer of my data to the United One platform to
            continue my registration.
          </P3>
        </Flexed>
      )}
      <Flexed center m='0 40px' mSM='0' onClick={getContentBlockHandler}>
        <Checkbox
          checkColor={colors.primary900}
          margin={'0 5px 0 0'}
          checked={checkbox}
          // onClick={() => setCheckbox(!checkbox)}
        />
        <Button
          h='40px'
          textColor={colors.primary900}
          textButton
          // onClick={getContentBlockHandler}
          w='auto'
          style={{ textAlign: 'left' }}>
          I agree with <b>Terms and Conditions</b>
        </Button>
      </Flexed>
      <Flexed
        mb='24'
        center
        m='0 40px'
        mbSM='24'
        mSM='0 '
        onClick={getPoliciesAndProceduresHandler}>
        <Checkbox
          checkColor={colors.primary900}
          margin={'0 5px 0 0'}
          checked={checkbox2}
          // onClick={() => setCheckbox2(!checkbox2)}
        />
        <Button
          h='40px'
          textColor={colors.primary900}
          textButton
          w='auto'
          style={{ textAlign: 'left' }}>
          I agree with <b>Policies and Procedures</b>
        </Button>
      </Flexed>
      <Flexed gap='15px' gapSM='10px' rowReverseSM justifyCenter>
        <Button
          textColor={lightTheme.colors.primary900}
          w='200px'
          textButton
          onClick={() => history.push(LOGIN)}>
          Cancel
        </Button>
        {/* <Button w='200px' negative onClick={() => history.push(LOGIN)}>
          Back
        </Button> */}
        <Button w='200px' onClick={handleSubmit}>
          Confirm
        </Button>
      </Flexed>
      <ContentBlockModal
        title='United One Terms & Conditions'
        subtitle='In order to register your account, we will need you to read and agree with our terms & conditions. Scroll down.'
        content={contentBlock?.content ?? ''}
        modal={modal}
        setModal={setModal}
        setCheckbox={(v) => setCheckbox(v)}
      />
      <ContentBlockModal
        title='Policies and Procedures'
        subtitle='In order to register your account, we will need you to read and agree with our Policies and Procedures. Scroll down.'
        content={contentBlock?.content ?? ''}
        modal={modal2}
        setModal={setModal2}
        setCheckbox={(v) => setCheckbox2(v)}
      />
    </Main>
  );
};

export default MigrationTermsPrivacy;
